// Ported from thor-ui (src/utils/validators.ts) — framework-agnostic domain rules.

/** Extract a human-readable message from a failed API call, falling back to `fallback`. */
export const serverErrMsg = (err, fallback) => {
    if (err?.serverErrors) {
        // Prefer an explicit message field (validation errors, business rule violations)
        if (err.serverErrors.message) return err.serverErrors.message;
        // For 5xx responses Spring Boot returns { timestamp, status, error, path } — not user-readable
        if (err.status >= 500) return fallback;
        const msg = Object.values(err.serverErrors).filter(Boolean).join(' ');
        if (msg) return msg;
    }
    return fallback;
};

export const isValidTrafficTotal = (total) => total >= 96 && total <= 101;

export const validateExperimentKey = (key) => {
    if (!key) return 'Key is required';
    if (!/^[a-z0-9_-]+$/.test(key)) {
        return 'Key must contain only lowercase letters, numbers, hyphens, and underscores';
    }
    return null;
};

export const validateEmail = (email) => {
    if (!email) return 'Email is required';
    if (!email.endsWith('@tripadvisor.com')) return 'Only @tripadvisor.com emails are allowed';
    return null;
};
